import React, { PropTypes } from 'react';
import classnames from 'classnames';

const LOGO = "https://www.crowdspring.com/blog/wp-content/uploads/2020/03/logo-pink-blue.png";

const Separator = ({ preTitle, title, content, hideLogo, hideTitleLine }) => {
  return (
    <section className={classnames("block block-separator", { "with-logo": !hideLogo })}>
      <div className="row align-center">
        <div className="columns small-16 large-10">
          <div className="box">
            { !!preTitle && <div className="pre-title">{ preTitle }</div> }
            <h2 className={classnames({ "with-border-bottom": !hideTitleLine })}>{ title }</h2>
            { !!content &&
            <div className="content" dangerouslySetInnerHTML={{ __html: content }} /> }
            { !hideLogo && <img className="logo" src={LOGO} /> }
          </div>
        </div>
      </div>
    </section>
  );
}

Separator.propTypes = {
  preTitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  hideLogo: PropTypes.bool,
  hideTitleLine: PropTypes.bool,
};

export default Separator;
